import clsx from 'clsx';

//type
import type { AlbumCardGridLayoutType, AlbumCardMedia } from '@/lib/albums/types';

import { getCardGridStyles } from '@/lib/albums/getCardGridStyles';
//libs
import { YOUTUBE } from '@/lib/socialProfile';

//components
import { MediaGridImage } from '@/components/pages/albums/AlbumCardMediaGrid/MediaGridImage';

function MediaGridYoutube({
    medias,
    gridLayout
}: {
    medias: AlbumCardMedia[];
    gridLayout: AlbumCardGridLayoutType;
}) {
    const maxMedias = gridLayout === 'card' ? 4 : 3;
    const renderedMedias = medias.length > maxMedias ? medias.slice(0, maxMedias) : medias;

    return (
        <>
            {renderedMedias.map((media, index) => (
                <span
                    data-testid="grid-youtube-video"
                    key={media.text}
                    className={clsx(
                        {
                            'row-span-9': medias.length === 3 && index === 0
                        },
                        getCardGridStyles({
                            index: index + 1,
                            size: renderedMedias?.length,
                            network: YOUTUBE,
                            gridLayout
                        })
                    )}>
                    <MediaGridImage
                        index={index}
                        image={media.medias?.[0]?.image ?? media?.medias?.[0]?.thumbnail}
                        type={media?.type}
                        size={medias?.length}
                        gridLayout={gridLayout}
                    />
                </span>
            ))}
        </>
    );
}

export default MediaGridYoutube;
